











import {Component, Vue, Prop} from 'vue-property-decorator'
import {Rate} from '@/lib/kepler/interfaces'

import TimeOverrides from '../../TimeOverrides.vue'
import DistanceOverrides from '../../DistanceOverrides.vue'
import BulkOverrides from '../../BulkOverrides.vue'
import PlanBaseRate from '../../subscriptions/PlanBaseRate.vue'
import Layout from '@/components/proxy/Layout.vue'
import Chip from '@/components/proxy/Chip.vue'
import Divider from '@/components/proxy/Divider.vue'

@Component({
  name: 'VehicleFares',
  components: {Divider, Chip, Layout, PlanBaseRate, BulkOverrides, DistanceOverrides, TimeOverrides},
})
export default class VehicleFares extends Vue {
  @Prop() public baseRate!: Rate

  public overrides(type: 'time' | 'distance' | 'bulk') {
    const b = this.baseRate[type + '_overrides']
    if (b && Array.isArray(b) && b.length > 0) {
      return b
    }
  }
}
